import React, { useEffect, useState } from 'react';
import StarRating from 'src/app/components/StarRating';
import { CardAvatarStack } from '@/components/ui/card-avatar-stack';
import { CourseStepImageKpis } from './course-step-image-kpis';
import { toast } from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import { t } from 'i18next';
import { Sheet, SheetBody, SheetContent, SheetFooter, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { CourseBanner, CourseBannerContainer, CourseBannerContent, CourseBannerDescription, CourseBannerTitle } from '@/components/custom/course';

export function CourseStepImageModalPreview(props) {
  const { show, onClose, src, form, courseId } = props;

  const client = useClient();
  const [detailedCourse, setDetailedCourse] = useState();
  const [managers, setManagers] = useState([]);
  const [students, setStudents] = useState([]);

  const getCourseDetails = async () => {
    const { data, error } = await client.fetch(`/courses/${courseId}?detailed=true`);
    if (error) {
      toast.error(t('toast.errorLoadCourseData'));
    } else {
      setDetailedCourse(data);
      const users = data.users;
      const managers = users.filter(item => !item['profile-names'].includes('Aluno'));
      const students = users.filter(item => item['profile-names'].includes('Aluno'));

      setManagers(managers);
      setStudents(students);
    }
  };

  useEffect(() => {
    if (courseId) {
      getCourseDetails();
    }
  }, []);

  return (
    <Sheet
      open={show}
      onOpenChange={onClose}
    >
      <SheetContent size="md">
        <SheetHeader>
          <SheetTitle className="sr-only">Pré-visualização do curso</SheetTitle>
        </SheetHeader>

        <SheetBody>
          <div
            className="course-about"
            style={{ boxShadow: 'none', padding: '0' }}
          >
            <CourseBanner
              backgroundUrl={src}
              className="min-h-[224px]"
            >
              <CourseBannerContent>
                <CourseBannerContainer>
                  <CourseBannerTitle>{form?.values?.title}</CourseBannerTitle>
                  <CourseBannerDescription>{form?.values?.about}</CourseBannerDescription>
                </CourseBannerContainer>
              </CourseBannerContent>
            </CourseBanner>

            <div className="course-about__header">
              <div className="course-about__container-header">
                <div className="course-about__inner-header">
                  <div className="course-about__infos">
                    <div className="course-about__rating">
                      <StarRating
                        staticRating
                        rating={courseId ? detailedCourse?.rating : 0}
                      />
                      <p className="course-about__rating-text">
                        <strong>{courseId ? parseFloat(detailedCourse?.rating).toFixed(2) : 0}</strong> ({courseId ? detailedCourse?.['total-reviews'] : 0} {t('courses.evaluations')})
                      </p>
                    </div>
                  </div>
                </div>

                <div className="course-about__participants">
                  <div className="card__avatar">
                    <h4 className="card__avatar-title">
                      {t('courses.managers')} ({courseId ? managers?.length : 0})
                    </h4>
                    {managers?.length > 0 && (
                      <CardAvatarStack
                        data={managers}
                        modalTitle={t('projects.titleProjectManagers')}
                      />
                    )}
                  </div>
                  <div className="card__avatar">
                    <h4 className="card__avatar-title">
                      {t('projects.titleStudents')} ({courseId ? students?.length : 0})
                    </h4>
                    {students?.length > 0 && (
                      <CardAvatarStack
                        data={students}
                        modalTitle={t('projects.titleProjectStudents')}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <CourseStepImageKpis course={detailedCourse} />
          </div>
        </SheetBody>

        <SheetFooter />
      </SheetContent>
    </Sheet>
  );
}
